/** The page background every board element is cased against. */
export const BOARD_BG = "#121212";

/**
 * Board role colours ("Mint ladder"). Start / target / current stay >= 15
 * CIEDE2000 apart under protan, deutan and tritan simulation, gold and purple
 * >= 30, and every role has >= 4.5:1 contrast on #121212
 * (see __tests__/boardPalette.cvd.test.ts). The only gold, purple and
 * AI-path colours in the app.
 */
export const ROLE_COLORS = {
  start: "#C4F5BD",
  target: "#F76980",
  current: "#61CAE5",
  path: "#EAEAEA",
  gold: "#FAD65F",
  purple: "#8A8EFE",
  ai: "#EB9F6A",
} as const;
